import ToggleSwitch from '../shared/ToggleSwitch';
import styles from './BudgetCreationForm.module.css';

/**
 * BudgetCreationForm Component
 *
 * Form fields for budget creation
 */
function BudgetCreationForm({
    budgetName,
    setBudgetName,
    startMonth,
    setStartMonth,
    singleBankMode,
    setSingleBankMode,
    availableMonths,
    isCreating,
    error
}) {
    return (
        <>
            {/* Budget Name */}
            <div className={styles.formField}>
                <label className={styles.label}>
                    Budget Name *
                </label>
                <input
                    type="text"
                    value={budgetName}
                    onChange={(e) => setBudgetName(e.target.value)}
                    placeholder="e.g., Family Budget, Personal Finances"
                    maxLength={100}
                    disabled={isCreating}
                    className={styles.input}
                />
                <small className={styles.characterCounter}>
                    {budgetName.length}/100 characters
                </small>
            </div>

            {/* Start Month */}
            <div className={styles.formField}>
                <label className={styles.label}>
                    Start Month *
                </label>
                <select
                    value={startMonth}
                    onChange={(e) => setStartMonth(e.target.value)}
                    disabled={isCreating}
                    className={styles.select}
                >
                    {availableMonths.map(month => (
                        <option key={month.value} value={month.value}>
                            {month.label}
                        </option>
                    ))}
                </select>
                <small className={styles.helperText}>
                    Choose when your budget tracking should begin
                </small>
            </div>

            {/* Single Bank Mode */}
            <div className={styles.toggleField}>
                <ToggleSwitch
                    checked={singleBankMode}
                    onChange={(checked) => setSingleBankMode(checked)}
                    label="This budget uses only one bank account"
                    disabled={isCreating}
                />
                <small className={styles.helperText}>
                    Enable this if you're tracking a single account (individual or joint). User categories will not be created.
                </small>
            </div>

            {/* Error Message */}
            {error && (
                <div className={styles.errorMessage}>
                    {error}
                </div>
            )}
        </>
    );
}

export default BudgetCreationForm;
